import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class SEOHiddenText extends Component {
  render(){
    return (
      <div>
        <h1 className="header-what-we-do-text">
          Furnished Living LA offers luxury furnished apartments in Santa Monica, West Hollywood, and Los Angeles.
        </h1>
        <a id="hidden-phone-number" className="header-what-we-do-text" href="tel:+14242584690">424.258.4690</a>
        <a id="hidden-email" className="header-what-we-do-text" href="mailto:info@furnishedlivingla.com">info@furnishedlivingla.com</a>
      </div>
    )
  }
}

export default SEOHiddenText;


/*

Meta tags -






*/



// WEBPACK FOOTER //
// ./src/SEOHiddenText.js